import React, { useState } from "react";
import beaker from "./beaker.png"; // outline of beaker
import fluid from "./fluid.png";   // fluid layer

export default function PHBalancer() {
    const [pH, setPH] = useState(4); // start slightly acidic
    const [gameWon, setGameWon] = useState(false);

    // Adjust pH
    function addAcid() {
        setPH(prev => Math.max(0, prev - 1));
    }

    function addBase() {
        setPH(prev => Math.min(14, prev + 1));
    }

    // Check for win
    if (pH === 7 && !gameWon) {
        setGameWon(true);
    }

    // Convert pH to fluid color
    function getFluidColor(pH) {
        // pH 0 = red (#ff4d4d), pH 7 = purple (#a64dff), pH 14 = blue (#4d4dff)
        if (pH < 7) {
            const ratio = pH / 7; // 0 = full red, 6 = almost purple
            const r = 255;
            const g = Math.round(77 * ratio);
            const b = Math.round(77 * ratio);
            return `rgb(${r},${g},${b})`;
        } else if (pH > 7) {
            const ratio = (pH - 7) / 7; // 0 = purple, 7 = blue
            const r = Math.round(166 * (1 - ratio));
            const g = Math.round(77 * (1 - ratio));
            const b = 255;
            return `rgb(${r},${g},${b})`;
        } else {
            return "rgb(166,77,255)"; // neutral purple
        }
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                backgroundColor: "#f0f0f0",
                fontFamily: "sans-serif",
            }}
        >
            {gameWon ? (
                <div style={{ textAlign: "center" }}>
                    <h1>🎉 Perfectly Neutral!</h1>
                    <p>pH = 7</p>
                </div>
            ) : (
                <>
                    <h1>🧪 pH Balancer</h1>
                    <p>Current pH: {pH.toFixed(1)}</p>

                    <div
                        style={{
                            position: "relative",
                            width: "200px",
                            height: "300px",
                            marginBottom: "20px",
                        }}
                    >
                        {/* Fluid layer */}
                        <div
                            style={{
                                position: "absolute",
                                bottom: 0,
                                width: "100%",
                                height: `${Math.min(Math.max(pH, 0), 14) / 14 * 100}%`,
                                backgroundColor: getFluidColor(pH),
                                borderRadius: "0 0 10px 10px",
                                transition: "height 0.3s, background-color 0.3s",
                                zIndex: 0,
                            }}
                        >
                            <img
                                src={fluid}
                                alt="fluid texture"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    opacity: 0.5,
                                }}
                            />
                        </div>

                        {/* Beaker overlay */}
                        <img
                            src={beaker}
                            alt="beaker"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                zIndex: 1,
                                pointerEvents: "none",
                            }}
                        />
                    </div>

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: "20px" }}>
                        <button
                            onClick={addAcid}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#ff4d4d",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                        >
                            Add Acid
                        </button>
                        <button
                            onClick={addBase}
                            style={{
                                padding: "10px 20px",
                                backgroundColor: "#4d4dff",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                        >
                            Add Base
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
